import { Link } from 'react-router-dom'

import { ProfileMenu } from '@/features/auth/components/profile-menu'
import { cn } from '@/lib/utils'
import type { AppRouteHandle } from './app-layout'

type AppLayoutHeaderProps = Pick<AppRouteHandle, 'title' | 'breadcrumbs'>

export const AppLayoutHeader = ({
  title,
  breadcrumbs,
}: AppLayoutHeaderProps) => (
  <header className="flex h-26 shrink-0 items-center justify-between bg-surface-tint px-8">
    <div className="flex flex-col gap-2">
      <h1 className="text-4xl font-bold text-foreground">{title}</h1>

      {breadcrumbs && breadcrumbs.length > 0 ? (
        <nav aria-label="Breadcrumb">
          <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1

              return (
                <li key={`${crumb.label}-${index}`} className="inline-flex items-center gap-1">
                  {index > 0 ? (
                    <span aria-hidden className="text-muted-foreground/60">
                      &gt;
                    </span>
                  ) : null}
                  {crumb.to ? (
                    <Link
                      to={crumb.to}
                      className={cn(
                        'underline transition-colors hover:text-foreground',
                        isLast && 'text-primary-dark'
                      )}
                      aria-current={isLast ? 'page' : undefined}
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span
                      className={cn(isLast && 'text-primary-dark')}
                      aria-current={isLast ? 'page' : undefined}
                    >
                      {crumb.label}
                    </span>
                  )}
                </li>
              )
            })}
          </ol>
        </nav>
      ) : null}
    </div>

    <ProfileMenu />
  </header>
)
